<style scoped>
    .empty-wrap {
        height: 300px;
    }
</style>
<template>
    <div class="match-list-table-wrap">
        <p class="sub-title">대진표</p>
        <div class="table-wrap" v-if="!indexingLoading">
            <table v-if="participantList.length > 0">
                <tr>
                    <td class="fix-side sortation">팀-이름</td>
                    <th class="participant-name" v-for="(participant) in participantList"
                        :key="participant.participantId">
                        <p>{{participant.participantName}}</p>
                    </th>
                </tr>
                <tr v-for="(participant, participantIndex) in participantList" :key="participant.participantId">
                    <td class="participant-name fix-side">
                        {{participant.participantName}}<br/>
                        <span v-if="!(participant.userList.length === 1 && participant.userList[0].playerName === participant.participantName)">
                            <span v-for="user in participant.userList" :key="user.playerId">{{user.playerName}} </span>
                        </span>

                    </td>
                    <td class="match-info-wrap" v-for="(match, matchIndex) in participant.matchList" @click="broadcastUrlFunc(match)"
                        :class="participantIndex !== matchIndex ? '':'null-match'"
                        :key="`match${participant.participantId}${matchIndex}`">

                        <!--경기전-->
                        <p class="match-info" v-if="match &&tournament.isTnmtTimeTablePublic =='Y'&& match.isPlaying !== 'D'">
                            {{getMatchTime(match.matchTime)}}<br/>
                            {{match.courtId}}코트 {{match.courtOrder}}
                        </p>

                        <!--경기 후-->
                        <div v-else-if="match && match.isPlaying === 'D' && (match.isOpponentRetired !== 'W' && match.isOpponentRetired!== 'A')" >
                            <p class="score">
                                <label class="video-icon" v-if="match.broadcastUrl"></label>
                                <label class="win"
                                       v-if="(participant.participantId === match.firstParticipantId && match.firstParticipantWinCount > match.secondParticipantWinCount)||
                                   (participant.participantId === match.secondParticipantId && match.firstParticipantWinCount < match.secondParticipantWinCount) ">
                                    승
                                </label>

                                <label class="lose"
                                       v-else-if="(participant.participantId === match.firstParticipantId && match.firstParticipantWinCount < match.secondParticipantWinCount)||
                                   (participant.participantId === match.secondParticipantId && match.firstParticipantWinCount > match.secondParticipantWinCount) ">
                                    패
                                </label>
                                <label class="draw"
                                       v-else-if="match.firstParticipantWinCount === match.secondParticipantWinCount">무</label>
                                <span v-if="participant.participantId === match.firstParticipantId" class="score">{{match.firstParticipantWinCount}} : {{match.secondParticipantWinCount}}</span>
                                <span v-else class="score">{{match.secondParticipantWinCount}} : {{match.firstParticipantWinCount}}</span>
                            </p>

                            <p class="description" v-if="participant.participantId === match.firstParticipantId">
                                <label>{{subStrName(match.firstParticipantName)}}</label> <label>:</label><label>{{subStrName(match.secondParticipantName)}}</label>
                            </p>
                            <p class="description" v-else >
                                <label>{{subStrName(match.secondParticipantName)}}</label> <label>:</label><label>{{subStrName(match.firstParticipantName)}}</label>
                            </p>
                        </div>
<!--                        상대방기권-->
                        <div v-else-if="match && match.isPlaying === 'D' && (match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A')">
                            <p class="is-opponent-retired" v-if="match.winnerParticipantId === participant.participantId">기권승</p>
                            <p class="is-opponent-retired" v-else>기권패</p>
<!--                            <p class="is-opponent-retired">기권승</p>-->
                        </div>
<!--                        둘다기권-->
                        <!--<div v-else-if="match && match.isPlaying === 'D' && match.isOpponentRetired === 'A'">
                            <p class="is-opponent-retired">기권패</p>
                        </div>-->
                    </td>
                </tr>
            </table>
            <EmptyContent content="등록된 대진표가 없습니다" v-else></EmptyContent>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";

    export default {
        computed: {
            ...mapState('tournaments', ['tournament', 'matches'])
        },
        components: {EmptyContent},
        props: ['participation_list'],
        data() {
            return {
                participantList: [],
                indexingLoading: false
            }
        },
        created() {
            this.indexingLoading = true

            const participantIndexingList = []
            const participantIds = [];
            this.matches.participantList.forEach(participant => {
                participantIndexingList[participant.participantId] = participant
                participantIds.push(participant.participantId)
            })

            this.participation_list.forEach((participant) => {
                const matchParticipantIndexingList = [];
                participant.matchList.forEach(match => {


                    if(match.firstParticipantId in participantIndexingList){
                        match.firstParticipantName = participantIndexingList[match.firstParticipantId].participantName
                    }
                    if(match.secondParticipantId in participantIndexingList){
                        match.secondParticipantName  = participantIndexingList[match.secondParticipantId].participantName
                    }


                    if(match.firstParticipantId !== participant.participantId){
                        matchParticipantIndexingList[match.firstParticipantId] = match
                    }else if(match.secondParticipantId !== participant.participantId){
                        matchParticipantIndexingList[match.secondParticipantId] = match
                    }
                })

                const matchList = [];
                participantIds.forEach(participantId => {
                    if(participantId in matchParticipantIndexingList){
                        matchList.push(matchParticipantIndexingList[participantId])
                    }else{
                        matchList.push(null)
                    }
                })

                participant.matchList = matchList
                this.participantList.push(participant)

            })
            this.indexingLoading = false
        },
        methods: {
            getMatchTime(matchTime) {
                const hour = matchTime.substr(0, 2)
                const min = matchTime.substr(2, 2)

                return `${hour}:${min}`
            },
            broadcastUrlFunc(match){
                const boradCastUrl = match.broadcastUrl
                if(boradCastUrl){
                    window.open(boradCastUrl)
                }
            },
            subStrName(name){
                name = name.substr(0, 4)
                return name
            }
        },
    }
</script>
